import InputMask from "react-input-mask";
import { Container } from "./style";

export const onlyNumbers = (str) => str.replace(/[^0-9]/g, "");

export const moneyMask = (str) => {
	let value = str;
	value = value.replace(/\D/g, "");
	value = value.replace(/(\d)(\d{2})$/, "$1,$2");
	value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

	return value;
};

export const CpfInput = ({ value, onChange, ...rest }) => {
	function handleChange(event) {
		onChange({
			...event,
			target: {
				...event.target,
				value: onlyNumbers(event.target.value),
			},
		});
	}

	return (
		<InputMask {...rest} mask="999.999.999-99" value={value} onChange={handleChange} />
	);
};

export const CnpjInput = ({ value, onChange, ...rest }) => {
	function handleChange(event) {
		onChange({
			...event,
			target: {
				...event.target,
				value: onlyNumbers(event.target.value),
			},
		});
	}

	return (
		<InputMask
			{...rest}
			mask="99.999.999/9999-99"
			value={value}
			onChange={handleChange}
		/>
	);
};

export const BirthdateInput = ({ value, onChange, ...rest }) => {
	return <InputMask {...rest} mask="99/99/9999" value={value} onChange={onChange} />;
};

export const HoursInput = ({ value, onChange, ...rest }) => {
	return <InputMask {...rest} mask="99:99" value={value} onChange={onChange} />;
};

export const TelInput = ({ value, onChange, ddd, ...rest }) => {
	function handleChange(event) {
		onChange({
			...event,
			target: {
				...event.target,
				value: onlyNumbers(event.target.value),
			},
		});
	}

	return (
		<Container>
			<InputMask
				{...rest}
				mask={ddd === "55" ? "(99)99999-9999" : ddd === "595" && "999 999999"}
				value={value}
				onChange={handleChange}
			/>
		</Container>
	);
};

export const ZipInput = ({ value, onChange, ...rest }) => {
	function handleChange(event) {
		onChange({
			...event,
			target: {
				...event.target,
				value: onlyNumbers(event.target.value),
			},
		});
	}

	return <InputMask {...rest} mask="99999-999" value={value} onChange={handleChange} />;
};

export const CardInput = ({ value, onChange, mask, ...rest }) => {
	return (
		<InputMask type="text" mask={mask} value={value} onChange={onChange} {...rest} />
	);
};

export const RgInput = ({ value, onChange, ...rest }) => {
	function handleChange(event) {
		onChange({
			...event,
			target: {
				...event.target,
				value: onlyNumbers(event.target.value),
			},
		});
	}

	return (
		<InputMask {...rest} mask="99.999.999-9" value={value} onChange={handleChange} />
	);
};
